import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { UserInfo } from 'src/app/app.component';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import{MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @ViewChild('imgRef', { static: false }) imgreference!: ElementRef;
  @Input() isDisplayMenuButton: boolean;
  @Input() isFormBlur: boolean;
  @Input() userInfo: UserInfo;

  @Output() public MenuClick = new EventEmitter<any>();
  @Output() public LogoutClick = new EventEmitter<any>();
  @Output() public toggleGlobalModal = new EventEmitter<boolean>();
  @Output() public DayNightClick = new EventEmitter<boolean>();
  @ViewChild('languageModal') languageModal: ElementRef;

  modalReference: any;
  languages: any = [];

  header_logo_Image_Path: string = ''
  isBright: boolean = true;

  lstTop5Query = [];
  lstQuery = [];

  constructor(public commonService: CommonService, private dataService: DataService, private modalService: NgbModal, private renderer: Renderer2, private route: Router, private encryptDecryptservice: EncryptDecryptService,public memorystore: MemoryStorageService) { }

  ngOnInit(): void {
    this.getLanguages();
    this.getHeaderLogoImagePath();
  }
  ngAfterViewInit() {
    this.renderer.removeAttribute(this.imgreference.nativeElement, 'aria-haspopup');
  }
  onMenuButtonClick() {
    this.MenuClick.emit();
  }

  onLogoutButtonClick() {
    this.LogoutClick.emit();
  }

  getHeaderLogoImagePath() {

    let params = new HttpParams();
    params = params.append('project_id',this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    this.dataService.getData('header_logo_Image_Path', params).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          // this.commonService.setUserInfoToLocalStorage('HeaderLogo', res.data[0].header_logo_image_path);
          this.memorystore.setItem('HeaderLogo', res.data[0].header_logo_image_path);
          //this.commonService.setUserInfoToLocalStorage('defaultroleId', res.data[0].roleId);
          EmmiterService.get("userInfo").emit();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error =>{
      if(error.includes("401")){
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    }
    );

  }

  getLanguages() {

    let body={
        xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    }

    this.dataService.getData('language', body).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          this.languages = res.data;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error =>{
      if(error.includes("401")){
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    });

  }

  changeLanguage(lan: any) {
    this.toggleGlobalModal.emit(false);
    this.isFormBlur = false;
    this.modalReference.close();
    // this.commonService.setUserInfoToLocalStorage('language', lan.language_name + ' (' + lan.language_code + ')');
    this.memorystore.setItem('language', lan.language_name + ' (' + lan.language_code + ')');
    EmmiterService.get("userInfo").emit();
  }


  onDayNightClick() {
    this.isBright = !this.isBright;

    //this.DayNightClick.emit(this.isBright);
    EmmiterService.get("DayNightClick").emit(this.isBright);
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  getStyle(): any {
    let style;

    if (this.isBright) {
      style = {}
    }
    else {
      style = { 'background': 'black' };
    }
    return style;
  }

  queryClick(queryId) {

  }

  getQueryStyle(i) {
    return this.lstTop5Query[i].IsRead == 0 ? { 'font-weight': 600 } : {};
  }
}
